// GOALS (must match default cell type in FunnelGoalType.java)
export const GOAL_API = 'api';
export const GOAL_EMAIL_CONFIRM = 'confirmEmail';
export const GOAL_FAILED_PURCHASE = 'failedPurchase';
export const GOAL_LEAD_SCORE_ACHIEVED = 'scoreAchieved';
export const GOAL_OPPORTUNITY_STAGE_MOVED = 'stageMove';
export const GOAL_PRODUCT_PURCHASED = 'purchase';
export const GOAL_PIPELINE_STAGE_MOVED = 'pipelineStageMove';
export const GOAL_QUOTE_STATUS = 'quote';
export const GOAL_TAG_APPLIED = 'tagApplied';
export const GOAL_SMART_FORM = 'smartForm';
export const GOAL_TASK_COMPLETED = 'taskComplete';
export const GOAL_WEB_PAGE_AUTOMATION = 'websiteTrigger';
export const GOAL_WORDPRESS_OPTIN = 'wordPress';
export const GOAL_UNLAYER_LANDING_PAGE = 'unlayerLandingPage';
export const GOAL_APPOINTMENT_EVENT = 'appointmentEvent';
export const GOAL_NOTE_APPLIED = 'noteApplied';
export const GOAL_LANDING_PAGE_SUBMITTED = 'landingPage';
export const GOAL_WEB_FORM = 'webform';
export const GOAL_THRYV_WHEN_PUBLIC_FORMS = 'thryv-webform';
export const GOAL_INTERNAL_FORM = 'internalForm';
export const GOAL_EMAIL_LINK_CLICKED = 'linkClick';
export const GOAL_CONVRRT_PAGE_BUILDER = 'convrrtLandingPage';

export const GOALS = {
    GOAL_API,
    GOAL_EMAIL_CONFIRM,
    GOAL_FAILED_PURCHASE,
    GOAL_LEAD_SCORE_ACHIEVED,
    GOAL_OPPORTUNITY_STAGE_MOVED,
    GOAL_PIPELINE_STAGE_MOVED,
    GOAL_PRODUCT_PURCHASED,
    GOAL_QUOTE_STATUS,
    GOAL_TAG_APPLIED,
    GOAL_SMART_FORM,
    GOAL_TASK_COMPLETED,
    GOAL_WEB_PAGE_AUTOMATION,
    GOAL_WORDPRESS_OPTIN,
    GOAL_UNLAYER_LANDING_PAGE,
    GOAL_APPOINTMENT_EVENT,
    GOAL_NOTE_APPLIED,
    GOAL_LANDING_PAGE_SUBMITTED,
    GOAL_WEB_FORM,
    GOAL_THRYV_WHEN_PUBLIC_FORMS,
    GOAL_INTERNAL_FORM,
    GOAL_EMAIL_LINK_CLICKED,
    GOAL_CONVRRT_PAGE_BUILDER,
};

export const STYLE_BY_META_TYPE = {
    [GOAL_PRODUCT_PURCHASED]: 'purchaseSuccess',
    [GOAL_WEB_FORM]: 'newsletterRequest',
};

export const GOAL_WORDPRESS_ICON = 'wordPress';
export const OTHER_ICON = 'other';

export const GOALS_ICON = {
    GOAL_WORDPRESS_ICON,
    OTHER_ICON,
};

export const DECISION_MODAL = {
    DECISION_DIAMOND: 'decision',
};

// PROCESSES (must match cell type in FlowItemType.java)
export const PROCESS_CANCEL_SUBSCRIPTION = 'cancelSubscription';
export const PROCESS_ACTION_SET = 'actionSet';
export const PROCESS_ADD_TO_SEQUENCE = 'addToSequence';
export const PROCESS_APPLY_REMOVE_TAG = 'tag';
export const PROCESS_AUTOMATED_SMS = 'automatedSms';
export const PROCESS_ASSIGN_OWNER = 'assignOwner';
export const PROCESS_CREATE_OPPORTUNITY = 'opportunity';
export const PROCESS_SEND_HTTP_POST = 'http';
export const PROCESS_SEND_HTTP_REQUEST = 'httpRequest';
export const PROCESS_CREATE_TASK = 'task';
export const PROCESS_CREATE_APPOINTMENT = 'appointment';
export const PROCESS_UNLAYER_EMAIL = 'unlayerEmail';
export const PROCESS_BARD_EMAIL = 'bardEmail';
export const PROCESS_LEGACY_EMAIL = 'email';
export const PROCESS_APPLY_NOTE = 'note';
export const PROCESS_CREATE_DEAL = 'deal';
export const PROCESS_SET_FIELD_VALUE = 'fieldValue';
export const PROCESS_MOVE_OPPORTUNITY = 'moveOpportunity';
export const PROCESS_CREATE_ORDER = 'createOrder';
export const PROCESS_EMAIL_CONFIRM = 'emailConfirm';
export const PROCESS_LETTER = 'letter';
export const COMMUNICATIONS_FAX = 'fax';
export const COMMUNICATIONS_LETTER = 'letter';
export const PROCESS_FULFILLMENT_LIST = 'fulfillment';

export const COMMUNICATIONS = {
    PROCESS_LEGACY_EMAIL,
    PROCESS_EMAIL_CONFIRM,
    COMMUNICATIONS_FAX,
    COMMUNICATIONS_LETTER,
};

export const PROCESSES = {
    PROCESS_CANCEL_SUBSCRIPTION,
    PROCESS_ACTION_SET,
    PROCESS_ADD_TO_SEQUENCE,
    PROCESS_APPLY_REMOVE_TAG,
    PROCESS_ASSIGN_OWNER,
    PROCESS_CREATE_OPPORTUNITY,
    PROCESS_SEND_HTTP_POST,
    PROCESS_SEND_HTTP_REQUEST,
    PROCESS_CREATE_APPOINTMENT,
    PROCESS_BARD_EMAIL,
    PROCESS_UNLAYER_EMAIL,
    PROCESS_CREATE_TASK,
    PROCESS_APPLY_NOTE,
    PROCESS_CREATE_DEAL,
    PROCESS_SET_FIELD_VALUE,
    PROCESS_AUTOMATED_SMS,
    PROCESS_MOVE_OPPORTUNITY,
    PROCESS_CREATE_ORDER,
    PROCESS_EMAIL_CONFIRM,
    PROCESS_FULFILLMENT_LIST,
    PROCESS_LETTER,
};

export const FLOW_TYPE_SETTING = {
    STOP: 'Stop',
    CONTINUE: 'Continue',
};

// TIMERS
export const TIMER_FIELD_CONTACT = 'timerContact';
export const TIMER_DATE = 'timerDate';
export const TIMER_DELAY = 'timerDelay';
export const TIMER_APPOINTMENT = 'timerAppointment';

export const TIMERS = {
    TIMER_FIELD_CONTACT,
    TIMER_DELAY,
    TIMER_DATE,
    TIMER_APPOINTMENT,
};

// ACTIONS
export const EDIT_FLOW_TYPE = 'flowType';
export const DELETE_CELL = 'cellDelete';
export const SHOW_CONFIG_MODAL_CHANGED = 'showConfigModalChanged';
export const GOAL_SETTING = 'goalSetting';
export const CONTEXT_MENU_EDIT = 'contextMenuEdit';
export const LEGACY_EMAIL_CONVERT = 'newEmailExperience';

export const ACTIONS = {
    EDIT_FLOW_TYPE,
    DELETE_CELL,
    SHOW_CONFIG_MODAL_CHANGED,
    GOAL_SETTING,
    CONTEXT_MENU_EDIT,
    LEGACY_EMAIL_CONVERT,
};

export const OPTION_CONSTANTS = {
    revert: 'revert',
    print: 'print',
    funnelWidget: 'funnelWidget',
    revision: 'revision',
    mergeFields: 'mergeFields',
    links: 'links',
    restoreVersion: 'restore',
    makeCopy: 'saveAs',
    rename: 'rename',
    copyViaContentPublishing: 'copyViaContentPublishing',
    renameAndEditCategory: 'editCategory',
    lock: 'lock',
    unlock: 'unlock',
    unpublish: 'unpublish',
    deleteCampaign: 'deleteCampaign',
    publishMarketplace: 'publishMarketplace',
    lockUnlock: 'lockUnlock',
    configItemScreen: 'configItemScreen',
};

export const CONSTANTS_STEALTH_MENU = {
    export: 'export',
    import: 'import',
    reset: 'reset',
    current: 'current',
    original: 'original',
    published: 'published',
};

export const AUTOMATION_STATUS = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    PUBLISHED_WITH_CHANGES: 'publishedWithChanges',
};

export const CREATE_OPPORTUNITY_USE_ROUND_ROBIN = '0';

export const CONSTANTS_EXTERNAL_LINKS = {
    noteAppliedKeapLink: 'https://help.keap.com/help/create-a-note-template-goal',
    noteAppliedClassicLink: 'https://help.infusionsoft.com/help/create-a-note-template-goal',
};

export const CELL_TYPE = {
    WHEN: 'when',
    THEN: 'then',
};

export const EDGE_VALIDATION_STATE = {
    INVALID: 'invalid',
    DECISION_TO_GOAL: 'decisionToGoal',
    VALID: 'valid',
    NONE: 'none',
    MISMATCHED_TIMERS: 'mismatchedTimers',
    MISMATCHED_FIELD_TIMER_FIELD: 'mismatchedField',
    TIMETRAVEL: 'timeTravel',
    NO_MULTIPLE_STARTS: 'noMultipleStarts',
    CONNECT_TO_START: 'connectToStart',
    INFINITE_LOOP: 'infiniteLoop',
    SINGLE_OUTGOING_EDGE: 'singleOutgoingEdge',
    ELEMENT_LINKED_TO_ONE_DD: 'elementLinkedToOneDD',
    REDUNDANT_DECISION_DIAMOND: 'redundantDecisionDiamond',
};

export const EDGE_VALIDATION_INVALID_STATES = [
    EDGE_VALIDATION_STATE.INVALID, // generic invalid state
    EDGE_VALIDATION_STATE.DECISION_TO_GOAL, // decision diamong connecting to goal
    EDGE_VALIDATION_STATE.CONNECT_TO_START,
    EDGE_VALIDATION_STATE.INFINITE_LOOP,
    EDGE_VALIDATION_STATE.SINGLE_OUTGOING_EDGE, // trying to split a sequence
    EDGE_VALIDATION_STATE.MISMATCHED_TIMERS,
    EDGE_VALIDATION_STATE.TIMETRAVEL, // field timers are not in chronological order
    EDGE_VALIDATION_STATE.MISMATCHED_FIELD_TIMER_FIELD, // field timers referencing different fields
    EDGE_VALIDATION_STATE.NO_MULTIPLE_STARTS, // can only have 1 start in a flow
    EDGE_VALIDATION_STATE.ELEMENT_LINKED_TO_ONE_DD, // element can only be linked to one decision diamond
    EDGE_VALIDATION_STATE.REDUNDANT_DECISION_DIAMOND, // decision diamond already exists between given elements
];

export const GRID_SIZE = 48;
export const BIG_CARD_WIDTH = (GRID_SIZE - 8) * 5;
export const BIG_CARD_ELEMENT_LIMIT = 3;
export const BIG_CARD_ELEMENT_OFFSET = 46;
export const BIG_CARD_PADDING_OFFSET = 50;
export const BIG_CARD_PADDING = 12;
export const BIG_CARD_ADDITIONAL_OPTIONS_HEIGHT = 28;
export const ADD_CONTACT_LIMIT = 6;
export const SEQUENCE_START_WIDTH = 70;
export const FLOW_TYPE = 'flow';
export const DECISION_TYPE = 'decision';
export const NOTES_TYPE = 'notes';
export const LEADSOURCE_TYPE = 'leadsource';
export const EDGE_TYPE = 'edge';
export const INTEGRATION_TRIGGER_TYPE = 'integrationTrigger';
export const INTEGRATION_ACTION_TYPE = 'integrationAction';
export const SEQUENCE_START = 'start';
export const MAIN_CANVAS_ID = '1';
export const TIMERS_TIME_INCREMENT = 15;

export const MOUSE_CLICK = {
    LEFT: 1,
    RIGHT: 3,
};
export const NOTE_WIDTH = 323;
export const NOTE_HEIGHT = 214;

export const NOTE_COLOR = {
    yellow: '#FFF8E4',
    blue: '#D6F0FF',
    pink: '#FFE2EB',
    green: '#E8F6E8',
    purple: '#EFE8FD',
};

export const STAGE_TYPE = {
    goal: 'goal',
    sequence: 'sequence',
};

export const STANDARD_CELL_SIZE = 64;
export const PRESET_FILTERS = {
    CURRENT: 'ACTIVE',
    LAST_24_HOURS: 'LAST_24_HOURS',
    LAST_7_DAYS: 'LAST_7_DAYS',
    LAST_30_DAYS: 'LAST_30_DAYS',
    CUSTOM: 'CUSTOM',
};


export const VALID_INCOMING_FLOW = {
    taskComplete: {
        PROCESS_CREATE_TASK,
    },
    linkClick: {
        PROCESS_BARD_EMAIL,
        PROCESS_UNLAYER_EMAIL,
        PROCESS_LEGACY_EMAIL,
        PROCESS_EMAIL_CONFIRM,
    },
};

export const NO_VALID_INCOMING_FLOW_ERROR = {
    taskComplete: 'funnel.campaign.task.completed.invalid.config',
};
export const EMAIL_CONFIRMATION_LINK_CLICK_NAME = 'Confirm Email';

export const EMAIL_CONFIRMATION_DELAY_TIMER_NAME = 'Wait at least 3 days and\nthen run on a weekday at\n8:00 AM';

export const EMAIL_CONFIRMATION_DEFAULT_DELAY_TIMER = {
    waitDelay: '3',
    waitDelayType: 'Day',
    runOnType: 'Weekday',
    timeOfDayType: 'At',
    startHour: '8',
    startMinute: '0',
    startAmPm: 'AM',
    name: EMAIL_CONFIRMATION_DELAY_TIMER_NAME,
    initialized: '1',
};

export const CELL_TOOLTIP = {
    dragToConnect: 'funnel.tooltip.dragToConnect',
    edgeCreation: 'funnel.tooltip.edgeCreation',
    sequenceContinue: 'funnel.tooltip.sequence.continue',
    sequenceStop: 'funnel.tooltip.sequence.stop',
    elementBroken: 'funnel.tooltip.status.broken',
    elementPublished: 'funnel.tooltip.status.published',
    elementPublishedWithChanges: 'funnel.tooltip.status.publishedWithChanges',
    elementSetupRequired: 'funnel.tooltip.status.setupRequired',
    elementReady: 'funnel.tooltip.status.ready',
};

export const EMAIL_CONFIRMATION_DEFAULT_LINK_CLICK = {
    name: EMAIL_CONFIRMATION_LINK_CLICK_NAME,
    configurable: '0',
    disabledConfigMsgCode: 'funnel.edit.goal.emailConfirm.logic',
    initialized: '1',
};

export const FULFILLMENT_DELIVERY_TYPE = {
    DASHBOARD: 'Dashboard',
    EMAIL: 'Email',
    DEFAULT_FROM_TYPE: '1',
    OTHER_FROM_TYPE: '-1',
    OWNER_DEFAULT_TYPE: '-1',
};

export const FULFILLMENT_CONFIG_STAGE = {
    DELIVERY: 0,
    BATCH: 1,
    CONTACT_LIST: 2,
};

export const FULFILLMENT_ATTACHMENT_TYPE = {
    LINK: 'Link',
    FILE: 'File',
};

export const FULFILLMENT_MENU_ITEMS = {
    TEST: {
        ID: 2,
        LABEL: 'funnel.edit.fulfillment.test',
        ICON: 'user',
        SUB_ICON: 'user',
        SUBMENU: 'test',
    },
    COPY: {
        ID: 3,
        LABEL: 'funnel.edit.fulfillment.copy',
        ICON: 'copy',
        SUB_ICON: 'campaign',
        SUBMENU: 'copy',
    },
};

export const FULFILLMENT_ATTACHMENT_PERCENT_THRESHOLD = 100;

export const MARKETING_EMAIL_TYPES = [
    PROCESS_BARD_EMAIL,
    PROCESS_UNLAYER_EMAIL,
    PROCESS_LEGACY_EMAIL,
    PROCESS_EMAIL_CONFIRM,
];

export const GOAL_ACHIEVEMENT_TYPE = {
    NOT_GLOBAL: '0',
    GLOBAL: '1',
};

export const WHEN_CELL_OPTIONS = [
    { name: GOALS.GOAL_API },
    { name: GOALS.GOAL_APPOINTMENT_EVENT },
    { name: GOALS.GOAL_CONVRRT_PAGE_BUILDER, defaultName: 'funnel.when.cell.convrrtLandingPage.defaultName' },
    { name: GOALS.GOAL_EMAIL_LINK_CLICKED },
    { name: GOALS.GOAL_FAILED_PURCHASE },
    { name: GOALS.GOAL_SMART_FORM },
    { name: GOALS.GOAL_INTERNAL_FORM },
    { name: GOALS.GOAL_UNLAYER_LANDING_PAGE, subLabel: 'New' },
    { name: GOALS.GOAL_LANDING_PAGE_SUBMITTED, subLabel: 'old' },
    { name: GOALS.GOAL_LEAD_SCORE_ACHIEVED },
    { name: GOALS.GOAL_NOTE_APPLIED },
    { name: GOALS.GOAL_OPPORTUNITY_STAGE_MOVED },
    { name: GOALS.GOAL_PIPELINE_STAGE_MOVED },
    { name: GOALS.GOAL_PRODUCT_PURCHASED },
    { name: GOALS.GOAL_QUOTE_STATUS },
    { name: GOALS.GOAL_TAG_APPLIED },
    { name: GOALS.GOAL_TASK_COMPLETED },
    { name: GOALS.GOAL_THRYV_WHEN_PUBLIC_FORMS },
    { name: GOALS.GOAL_WEB_FORM },
    { name: GOALS.GOAL_WEB_PAGE_AUTOMATION },
    { name: GOALS.GOAL_WORDPRESS_OPTIN },
];

export const THEN_CELL_OPTIONS = [
    { name: PROCESSES.PROCESS_ADD_TO_SEQUENCE },
    { name: PROCESSES.PROCESS_APPLY_NOTE },
    { name: PROCESSES.PROCESS_APPLY_REMOVE_TAG },
    { name: TIMERS.TIMER_APPOINTMENT },
    { name: PROCESSES.PROCESS_ASSIGN_OWNER },
    { name: PROCESSES.PROCESS_CANCEL_SUBSCRIPTION },
    { name: PROCESSES.PROCESS_CREATE_DEAL },
    { name: PROCESSES.PROCESS_LETTER },
    { name: PROCESSES.PROCESS_CREATE_TASK },
    { name: PROCESSES.PROCESS_CREATE_APPOINTMENT },
    { name: PROCESSES.PROCESS_CREATE_ORDER },
    { name: PROCESSES.PROCESS_CREATE_OPPORTUNITY },
    { name: TIMERS.TIMER_DATE },
    { name: TIMERS.TIMER_DELAY },
    { name: TIMERS.TIMER_FIELD_CONTACT },
    { name: COMMUNICATIONS.PROCESS_EMAIL_CONFIRM, defaultName: 'funnel.edit.emailConfirm.cell.default.name' },
    { name: PROCESSES.PROCESS_FULFILLMENT_LIST },
    { name: PROCESSES.PROCESS_MOVE_OPPORTUNITY },
    { name: PROCESSES.PROCESS_SEND_HTTP_REQUEST },
    { name: PROCESSES.PROCESS_UNLAYER_EMAIL },
    { name: COMMUNICATIONS.PROCESS_LEGACY_EMAIL, subLabel: 'Legacy' },
    { name: PROCESSES.PROCESS_AUTOMATED_SMS },
    { name: PROCESSES.PROCESS_SET_FIELD_VALUE },
    { name: SEQUENCE_START },
];

// intentionally redundant to reduce core dependencies
export const SAVE_STATUS = {
    NONE: 'none',
    FAILED: 'failed',
    SUCCESS: 'success',
    SAVING: 'saving',
};
